import NodeCache from 'node-cache';

const DEFAULT_TTL_SECONDS = 300;
const MAX_KEYS = 2000;

declare global {
  // eslint-disable-next-line no-var -- must be var for global augmentation
  var __nodeCache: NodeCache | undefined;
}

if (!global.__nodeCache) {
  global.__nodeCache = new NodeCache({
    stdTTL: DEFAULT_TTL_SECONDS,
    checkperiod: 320,
    useClones: false,
    maxKeys: MAX_KEYS,
  });
}

const cache = global.__nodeCache;

const getKey = (key: string) => {
  const value = cache.get(key);
  return value;
};

const setKey = (key: string, value: unknown) => {
  return cache.set(key, value);
};

const deleteKey = (key: string) => {
  return cache.del(key);
};

const hasKey = (key: string) => cache.has(key);

const flushAll = () => cache.flushAll();

const allKeys = () => cache.keys();

export { cache, getKey, setKey, deleteKey, hasKey, flushAll, allKeys };
